const Styles = {
  notificationsTooltip: {
    position: "relative",
    top: "4px",
    left: "4px",
  },

  option: {
    "&.MuiAutocomplete-option[aria-disabled='true']": {
      pointerEvents: "inherit",

      "&:active": {
        pointerEvents: "none",
      },
    },
  },
};

export default Styles;
